import React from 'react';
import { Form, Field } from 'react-final-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';

import { required, phoneNumber } from '../../../forms';

const validate = (values) => {
  const errors = {}
  // TODO add validation
  return errors;
};

export const renderBootstrapField = ({ input, label, type, meta: { touched, error, warning },}) => (
  <InputGroup>
    { label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
    />
    {touched &&
      ((error && <p className="alert alert-danger">{error}</p>) ||
        (warning && <p className={warning.className}>{warning.msg}</p>))}
  </InputGroup>
);

export const renderPhoneField = ({ input, label, type, meta: { touched, error, warning },}) => (
  <InputGroup>
    { label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
    />
    {touched &&
      ((error && <p className="alert alert-danger">{error}</p>) ||
        (warning && <p className={warning.className}>{warning.msg}</p>))}
  </InputGroup>
);

const ProfileForm = ({ onSubmit, initialValues, onClose }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    render={({ handleSubmit, reset, submitting, pristine, errors }) => (
      <form onSubmit={handleSubmit}>
        <FormGroup>
          <Field
            name="user.first_name"
            type="text"
            component={renderBootstrapField}
            label="First Name"
            validate={required}
          />
          <Field
            name="user.last_name"
            type="text"
            component={renderBootstrapField}
            label="Last Name"
            validate={required}
          />
          <Field
            name="title"
            type="text"
            component={renderBootstrapField}
            label="Title"
          />
        </FormGroup>
        <FormGroup>
          <Field
            name="mobile"
            type="text"
            component={renderPhoneField}
            label="Mobile"
          />
          <Field
            name="office"
            type="text"
            component={renderPhoneField}
            label="Office"
          />
        </FormGroup>
        <FormGroup>
          <ButtonToolbar>
            <Button
              disabled={pristine || submitting}
              bsStyle="info"
              type="submit"
            >
               Save
            </Button>
            <Button
              onClick={onClose}
              bsStyle="info"
            >
              Cancel
            </Button>
          </ButtonToolbar>
        </FormGroup>
      </form>
    )}
  />
  );

export default ProfileForm;



// WEBPACK FOOTER //
// src/routes/profile/components/ProfileForm.js